import { render, staticRenderFns } from "./PaymentPointOfSales.vue?vue&type=template&id=3a8feb83&"
import script from "./PaymentPointOfSales.vue?vue&type=script&lang=js&"
export * from "./PaymentPointOfSales.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPointOfSales.vue?vue&type=style&index=0&id=3a8feb83&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports